var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Container, ContainerFlexAlignItems, ContainerFlexJustifyContents, ContainerPositions, ContainerWidths } from '../container';
import { StickyScreenPositions } from './types';
import { getAttributes, useThemeUtils } from '../../../utils';
var S = function (_a) {
    var props = __rest(_a, []);
    var id = props.id, isShown = props.isShown, screenPosition = props.screenPosition, children = props.children, rest = __rest(props, ["id", "isShown", "screenPosition", "children"]);
    var themeUtils = useThemeUtils();
    var containerRef = useRef(null);
    var stickyHorizontalPositionConfig = {
        left: 0,
        right: 0
    };
    var configSticky = __assign({ id: id, innerRef: containerRef, width: ContainerWidths.Full, flexJustifyContent: ContainerFlexJustifyContents.Center, flexAlignItems: ContainerFlexAlignItems.Center, position: ContainerPositions.Fixed, zIndex: 700, className: [
            'sticky-container',
            screenPosition === StickyScreenPositions.Bottom && 'bottom',
            screenPosition === StickyScreenPositions.Top && 'top',
            isShown && 'show'
        ]
            .filter(Boolean)
            .join(' '), positionCoordinates: themeUtils.getResponsiveProp([
            screenPosition === StickyScreenPositions.Bottom
                ? __assign(__assign({}, stickyHorizontalPositionConfig), { bottom: 0 }) : __assign(__assign({}, stickyHorizontalPositionConfig), { top: 0 })
        ]) }, getAttributes(rest));
    return React.createElement(Container, __assign({}, configSticky), children);
};
export { S as Sticky };
